function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  x: "-191.7%",
  y: "-25.1%",
  width: "483.3%",
  height: "150.2%",
  filterUnits: "objectBoundingBox",
  id: "step_1_svg__d"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 7.813,
  "in": "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  x: "-9.7%",
  y: "-15.2%",
  width: "119.4%",
  height: "130.4%",
  filterUnits: "objectBoundingBox",
  id: "step_1_svg__e"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.432,
  "in": "SourceGraphic"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "100%",
  y1: "50%",
  x2: "26.923%",
  y2: "50%",
  id: "step_1_svg__c"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D4EACA",
  offset: "100%"
})), /*#__PURE__*/React.createElement("circle", {
  id: "step_1_svg__a",
  cx: 78.125,
  cy: 78.125,
  r: 78.125
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(25 17.188)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "step_1_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#step_1_svg__a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#E5F3FC",
  xlinkHref: "#step_1_svg__a"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#step_1_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M118.069 39.793v159.326H58.136c-8.065-2.504-13.038-6.813-14.916-12.927-1.11-3.638 3.902-10.359 15.04-20.162l-.547-47.163c-3.708-19.116-5.056-33.356-4.044-42.72 1.518-14.003-9.916-26.413-4.51-33.707 1.34-1.813 7.942-2.95 5.964-2.647h62.946z",
  fill: "url(#step_1_svg__c)",
  fillRule: "nonzero",
  transform: "rotate(90 63.381 133.494)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M81.523 114.644c2.625 3.484-.555 8.253-9.54 14.304-13.478 9.077-9.275 20.053-14.588 23.686",
  stroke: "#8CD6F0",
  strokeWidth: 1.563,
  strokeLinecap: "square",
  strokeDasharray: "6.25,10.9375"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.844 46.829c.2 0 .397-.015.59-.044.187.03.38.044.576.044 2.163 0 3.918-1.775 3.918-3.964 0-2.19-1.755-3.964-3.918-3.964-.196 0-.389.015-.577.043a4.097 4.097 0 00-.589-.043h-.539c-.283-3.175-2.92-5.662-6.131-5.662-3.212 0-5.849 2.487-6.132 5.661l-3.897.001a3.964 3.964 0 100 7.928h16.7z",
  fill: "#BFF3FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.835 120.203c25.909-19.762 46.699-31.05 62.371-33.863 15.672-2.813 24.224 8.475 25.656 33.863H51.835z",
  fill: "#BEE5AA",
  opacity: 0.392
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.777 63.836c1.844 10.442 3.43 26.367 3.093 41.11-.34 14.742-2.599 28.276-5.157 34.932-2.558 6.631-5.411 6.359-6.479-2.54-1.064-8.923-.338-26.496.175-36.761.514-10.29.816-13.27 1.167-21.582.35-8.286.746-21.928 1.995-26.244 1.254-4.341 3.357.643 5.206 11.085z",
  fill: "#8CD6F0",
  fillRule: "nonzero",
  filter: "url(#step_1_svg__d)",
  transform: "rotate(90 50.908 125.878)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M111.845 134.16c-10.295 1.845-25.997 3.43-40.532 3.094-14.535-.34-28.34-2.64-34.903-5.197-6.537-2.558-5.808-5.371 2.966-6.44 8.797-1.063 26.124-.338 36.245.176 10.145.514 13.084.816 21.278 1.166 8.17.351 22.255-.19 26.51 1.06 4.28 1.253-1.269 4.293-11.564 6.141z",
  fill: "#8CD6F0",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.25,
  fill: "#000",
  filter: "url(#step_1_svg__e)",
  d: "M23.439 52.52h75.327v47.931H23.439z",
  transform: "translate(24.154 31.94)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.166 37.289a.433.433 0 01.689.321l.123 3.07 2.671 1.73c.295.19.248.62-.079.725l-2.965.963-.78 2.948c-.087.325-.523.4-.739.127l-1.956-2.475-3.153.093c-.348.01-.57-.373-.377-.648l1.756-2.492-1.168-2.89c-.13-.32.17-.631.505-.528l3.041.935 2.432-1.88zM29.393 54.418a.433.433 0 01.75-.132l1.862 2.445 3.18-.116c.35-.013.558.365.35.64l-1.876 2.49 1.051 2.862c.116.316-.198.628-.531.528l-3.022-.906-2.53 1.884c-.28.209-.681.023-.68-.314l.009-3.049-2.615-1.697c-.289-.187-.223-.614.111-.722l3.028-.979.913-2.934zM65.422 34.381c.062-.188.328-.235.45-.079l1.107 1.41 1.906-.079c.21-.008.334.21.209.37l-1.134 1.45.62 1.655c.068.183-.121.364-.32.308L66.45 38.9l-1.523 1.102c-.168.122-.408.016-.407-.18l.017-1.767-1.561-.974c-.173-.108-.132-.355.069-.419l1.818-.578.558-1.704z",
  fill: "#FFC832",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#BBE6F6",
  strokeWidth: 1.216,
  strokeLinecap: "round",
  d: "M52.319 38.25l8.222 12.492M107.819 32.066l-8.885 13.385M126.054 49.977l-6.962 5.162M49.252 61.625l-4.873-3.028"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.627 57.327c.062-.188.327-.235.45-.08l1.107 1.41 1.906-.078c.21-.009.334.21.209.37l-1.134 1.45.62 1.654c.068.183-.121.365-.321.308l-1.808-.514-1.523 1.102c-.168.121-.408.015-.407-.18l.017-1.767-1.561-.975c-.173-.107-.132-.355.069-.418l1.818-.578.558-1.704z",
  fill: "#FFC832",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(28.615 40.603)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#E6BE94",
  d: "M95.042 88.265H4.634V47.176h18.705l26.499-25.87 26.5 25.87h18.704z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#996459",
  d: "M40.485 70.003H59.19v18.262H40.485z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58.8 63.916H40.876c-.215 0-.39.17-.39.38v5.707h18.706v-5.707c0-.21-.175-.38-.39-.38z",
  fill: "#BBE6F6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.225 9.13l2.54-3.72a1.493 1.493 0 00.078-1.562 1.564 1.564 0 00-1.375-.804H49.881c-.862 0-1.56.68-1.56 1.521v9.131c0 .841.698 1.522 1.56 1.522h15.587c.576 0 1.104-.309 1.375-.804a1.493 1.493 0 00-.078-1.562l-2.54-3.721z",
  fill: "#F7B500"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.88 22.827c-.86 0-1.558-.68-1.558-1.522V1.522C48.322.68 49.019 0 49.88 0c.861 0 1.558.68 1.558 1.522v19.783c0 .841-.697 1.522-1.558 1.522z",
  fill: "#5C546A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.192 28.332c.24-.57.81-.94 1.44-.94H87.25a1.57 1.57 0 011.315.705l10.911 16.74c.306.47.325 1.062.052 1.55-.274.486-.798.789-1.367.789H74.78c-.415 0-.81-.16-1.103-.446L56.53 29.99a1.493 1.493 0 01-.338-1.658zM43.527 28.332c-.24-.57-.81-.94-1.44-.94H12.47a1.57 1.57 0 00-1.315.705L.244 44.837a1.494 1.494 0 00-.052 1.55c.274.486.797.789 1.367.789H24.94c.414 0 .81-.16 1.102-.446L43.19 29.99c.446-.435.58-1.089.338-1.658z",
  fill: "#FF4F19"
}), /*#__PURE__*/React.createElement("path", {
  d: "M76.359 48.677c-.4 0-.798-.148-1.102-.446L49.88 23.457 24.505 48.231a1.585 1.585 0 01-2.204 0 1.496 1.496 0 010-2.152l26.478-25.85a1.585 1.585 0 012.204 0L77.46 46.08a1.496 1.496 0 010 2.152 1.574 1.574 0 01-1.102.446z",
  fill: "#E23601"
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#FFFCF5",
  cx: 49.881,
  cy: 47.176,
  rx: 9.353,
  ry: 9.131
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.88 41.089c-.86 0-1.558.68-1.558 1.522v3.043h-3.118c-.861 0-1.558.68-1.558 1.522 0 .841.697 1.522 1.558 1.522h4.677c.861 0 1.558-.68 1.558-1.522v-4.565c0-.842-.697-1.522-1.558-1.522z",
  fill: "#5C546A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.22 57.068c0-2.101-1.745-3.805-3.897-3.805-2.153 0-3.897 1.704-3.897 3.805 0 .26.027.515.078.76h-.078v6.088h7.794v-6.087h-.079c.051-.246.079-.5.079-.761z",
  fill: "#BBE6F6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.365 51.741c-3.008 0-5.455 2.39-5.455 5.327v6.848c0 .841.697 1.522 1.558 1.522h7.794c.862 0 1.559-.68 1.559-1.522v-6.848c0-2.937-2.448-5.327-5.456-5.327zm0 3.044c1.29 0 2.338 1.024 2.338 2.283v.76h-4.676v-.76c0-1.259 1.049-2.283 2.338-2.283zm-2.338 7.61v-1.523h4.676v1.522h-4.676z",
  fill: "#7E5C62"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BBE6F6",
  d: "M26.5 71.525h7.793v9.131H26.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.293 70.003h-7.794c-.861 0-1.559.68-1.559 1.522v9.13c0 .842.698 1.523 1.56 1.523h7.793c.862 0 1.559-.681 1.559-1.522v-9.131c0-.841-.697-1.522-1.559-1.522zm-1.559 3.044v1.522h-4.676v-1.522h4.676zm-4.676 6.087v-1.522h4.676v1.522h-4.676z",
  fill: "#7E5C62"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BBE6F6",
  d: "M12.428 71.525h7.794v9.131h-7.794z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.221 70.003h-7.794c-.861 0-1.558.68-1.558 1.522v9.13c0 .842.697 1.523 1.558 1.523h7.794c.862 0 1.56-.681 1.56-1.522v-9.131c0-.841-.698-1.522-1.56-1.522zm-1.558 3.044v1.522h-4.677v-1.522h4.677zm-4.677 6.087v-1.522h4.677v1.522h-4.677z",
  fill: "#7E5C62"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BBE6F6",
  d: "M79.498 71.525h7.794v9.131h-7.794z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.291 70.003h-7.794c-.861 0-1.558.68-1.558 1.522v9.13c0 .842.697 1.523 1.558 1.523h7.794c.862 0 1.559-.681 1.559-1.522v-9.131c0-.841-.697-1.522-1.559-1.522zm-1.559 3.044v1.522h-4.676v-1.522h4.676zm-4.676 6.087v-1.522h4.676v1.522h-4.676z",
  fill: "#7E5C62"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BBE6F6",
  d: "M65.426 71.525h7.794v9.131h-7.794z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.22 70.003h-7.794c-.862 0-1.559.68-1.559 1.522v9.13c0 .842.697 1.523 1.559 1.523h7.794c.861 0 1.558-.681 1.558-1.522v-9.131c0-.841-.697-1.522-1.558-1.522zm-1.56 3.044v1.522h-4.676v-1.522h4.677zm-4.676 6.087v-1.522h4.677v1.522h-4.677z",
  fill: "#7E5C62"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.206 57.068c0-2.101-1.745-3.805-3.897-3.805-2.152 0-3.897 1.704-3.897 3.805 0 .26.028.515.079.76h-.079v6.088h7.794v-6.087h-.078c.05-.246.078-.5.078-.761z",
  fill: "#BBE6F6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.352 51.741c-3.008 0-5.456 2.39-5.456 5.327v6.848c0 .841.697 1.522 1.559 1.522h7.794c.861 0 1.558-.68 1.558-1.522v-6.848c0-2.937-2.447-5.327-5.455-5.327zm0 3.044c1.289 0 2.338 1.024 2.338 2.283v.76h-4.677v-.76c0-1.259 1.05-2.283 2.339-2.283zm-2.339 7.61v-1.523h4.677v1.522h-4.677z",
  fill: "#7E5C62"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M20.179 57.068c0-2.101-1.745-3.805-3.897-3.805-2.152 0-3.897 1.704-3.897 3.805 0 .26.027.515.079.76h-.079v6.088h7.794v-6.087H20.1c.051-.246.079-.5.079-.761z",
  fill: "#BBE6F6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.324 51.741c-3.008 0-5.455 2.39-5.455 5.327v6.848c0 .841.697 1.522 1.558 1.522h7.794c.862 0 1.56-.68 1.56-1.522v-6.848c0-2.937-2.449-5.327-5.457-5.327zm0 3.044c1.29 0 2.339 1.024 2.339 2.283v.76h-4.677v-.76c0-1.259 1.05-2.283 2.338-2.283zm-2.338 7.61v-1.523h4.677v1.522h-4.677z",
  fill: "#7E5C62"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M34.165 57.068c0-2.101-1.745-3.805-3.897-3.805-2.152 0-3.897 1.704-3.897 3.805 0 .26.028.515.079.76h-.079v6.088h7.794v-6.087h-.078c.05-.246.078-.5.078-.761z",
  fill: "#BBE6F6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.31 51.741c-3.007 0-5.455 2.39-5.455 5.327v6.848c0 .841.697 1.522 1.559 1.522h7.794c.861 0 1.559-.68 1.559-1.522v-6.848c0-2.937-2.448-5.327-5.456-5.327zm0 3.044c1.29 0 2.34 1.024 2.34 2.283v.76h-4.677v-.76c0-1.259 1.048-2.283 2.338-2.283zm-2.337 7.61v-1.523h4.676v1.522h-4.676z",
  fill: "#7E5C62"
})), /*#__PURE__*/React.createElement("path", {
  d: "M49.88 57.829c-6.016 0-10.91-4.779-10.91-10.653 0-5.874 4.894-10.653 10.91-10.653 6.017 0 10.912 4.779 10.912 10.653 0 5.874-4.895 10.653-10.911 10.653zm0-18.262c-4.297 0-7.793 3.413-7.793 7.609s3.496 7.61 7.794 7.61c4.297 0 7.794-3.414 7.794-7.61s-3.497-7.609-7.794-7.609zM56.116 62.394h-12.47c-2.579 0-4.677 2.048-4.677 4.566v21.305c0 .841.697 1.522 1.56 1.522.86 0 1.558-.681 1.558-1.522v-16.74h6.192v16.74h3.118v-16.74h6.278v16.74c0 .841.697 1.522 1.558 1.522.862 0 1.56-.681 1.56-1.522V66.96c0-2.518-2.099-4.566-4.677-4.566zm1.559 6.087H42.087V66.96c0-.84.699-1.522 1.559-1.522h12.47c.86 0 1.559.682 1.559 1.522v1.521z",
  fill: "#7E5C62"
}), /*#__PURE__*/React.createElement("path", {
  d: "M94.895 89.787H4.541c-.806 0-1.458-.681-1.458-1.522s.652-1.522 1.458-1.522h90.354c.806 0 1.458.68 1.458 1.522 0 .841-.652 1.522-1.458 1.522z",
  fill: "#5C546A"
})), /*#__PURE__*/React.createElement("path", {
  d: "M21.72 113.717c5.374 0 9.73-3.979 9.73-8.887S21.72 91.48 21.72 91.48s-9.729 8.443-9.729 13.351c0 4.908 4.356 8.887 9.73 8.887z",
  fill: "#FFD86C"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F0F0F0",
  strokeWidth: 1.563,
  strokeLinecap: "square",
  d: "M21.257 103.525v20.385"
}))), /*#__PURE__*/React.createElement("circle", {
  stroke: "#DA4D7A",
  strokeWidth: 2.143,
  cx: 186.745,
  cy: 149.245,
  r: 5.495
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#45C94E",
  cx: 9.375,
  cy: 141.345,
  r: 6.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.289.529c.798 0 1.444.647 1.444 1.444v3.852h3.852c.75 0 1.368.573 1.438 1.305l.006.14c0 .797-.646 1.444-1.444 1.444l-3.853-.001.001 3.853c0 .75-.573 1.367-1.305 1.437l-.14.007a1.444 1.444 0 01-1.443-1.444V8.713h-3.852c-.751 0-1.368-.572-1.438-1.304l-.007-.14c0-.797.647-1.444 1.445-1.444h3.851V1.973c0-.75.573-1.367 1.306-1.437z",
  fill: "#F9BA48",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#0086D8",
  strokeWidth: 2.143,
  cx: 152.636,
  cy: 16.433,
  r: 5.495
}), /*#__PURE__*/React.createElement("path", {
  d: "M192.586 64.591c.798 0 1.444.647 1.444 1.445v3.851h3.852c.751 0 1.368.573 1.438 1.306l.007.139c0 .798-.647 1.444-1.445 1.444h-3.852v3.852c0 .75-.572 1.368-1.305 1.438l-.139.007a1.444 1.444 0 01-1.444-1.445v-3.853l-3.852.001c-.75 0-1.368-.572-1.438-1.305l-.006-.139c0-.798.646-1.444 1.444-1.444h3.852v-3.852c0-.75.573-1.368 1.305-1.438z",
  fill: "#45C94E",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#0086D8",
  cx: 25,
  cy: 70.313,
  r: 25
}), /*#__PURE__*/React.createElement("text", {
  fontFamily: "ProximaNova-Bold, Proxima Nova",
  fontSize: 25,
  fontWeight: "bold",
  letterSpacing: -0.417,
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 18.508,
  y: 76.125
}, "1")));

function SvgStep1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 175,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/step_1.5a1af181.svg";
export { SvgStep1 as ReactComponent };